import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIList from 'UIComponents/list/UIList';
import * as EnrollmentFilterOperators from 'customer-data-filters/converters/objectSeg/ObjectSegOperatorTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/*
Context: Some "property value changed" events could show operators that are based off of persisted/historical info
And so aren't possible to enroll on. Only about 150 portals affected across NA/EU, should eventually delete this (11/27/23)
https://issues.hubspotcentral.com/browse/WORKFLOWS-15928
https://hubspot.slack.com/archives/CA3JB5WLT/p1694095971288549
https://hubspot.slack.com/archives/C0DS5D8JF/p1698862765872029
*/ // static list of historical operators incorrectly displayed
const INVALID_OPERATORS = [EnrollmentFilterOperators.HAS_EVER_BEEN_EXACTLY, EnrollmentFilterOperators.HAS_EVER_CONTAINED_ALL, EnrollmentFilterOperators.HAS_EVER_BEEN_ANY_OF, EnrollmentFilterOperators.HAS_EVER_BEEN_EQUAL_TO, EnrollmentFilterOperators.HAS_EVER_CONTAINED, EnrollmentFilterOperators.HAS_NEVER_BEEN_ANY_OF, EnrollmentFilterOperators.HAS_NEVER_BEEN_EQUAL_TO, EnrollmentFilterOperators.HAS_NEVER_BEEN_EXACTLY, EnrollmentFilterOperators.HAS_NEVER_CONTAINED_ALL, EnrollmentFilterOperators.HAS_NEVER_CONTAINED];
const OPERATOR_LANG_KEY_MAP = {
  [EnrollmentFilterOperators.HAS_EVER_BEEN_EXACTLY]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.EverEqual',
  [EnrollmentFilterOperators.HAS_EVER_CONTAINED_ALL]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.EverContainedAll',
  [EnrollmentFilterOperators.HAS_EVER_BEEN_ANY_OF]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.EverEqualAny',
  [EnrollmentFilterOperators.HAS_EVER_BEEN_EQUAL_TO]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.EverEqual',
  [EnrollmentFilterOperators.HAS_EVER_CONTAINED]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.EverContained',
  [EnrollmentFilterOperators.HAS_NEVER_BEEN_ANY_OF]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.NeverEqualAny',
  [EnrollmentFilterOperators.HAS_NEVER_BEEN_EQUAL_TO]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.NeverEqual',
  [EnrollmentFilterOperators.HAS_NEVER_BEEN_EXACTLY]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.NeverEqual',
  [EnrollmentFilterOperators.HAS_NEVER_CONTAINED_ALL]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.NeverContainedAll',
  [EnrollmentFilterOperators.HAS_NEVER_CONTAINED]: 'automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.operators.NeverContained'
};
export const shouldShowPropertyValueChangedWarning = triggers => {
  return !!(triggers && triggers.filterBranches.some(filterBranch => filterBranch.filterBranches[0] && filterBranch.filterBranches[0].filters.some(filter => 'property' in filter && filter.property === 'hs_value' && INVALID_OPERATORS.includes(filter.operation.operator))));
};
const PropertyValueChangedWarningBanner = ({
  triggers
}) => {
  const invalidPropertyValueChangedOperators = triggers.filterBranches.reduce((acc, filterBranch) => {
    filterBranch.filterBranches[0].filters.forEach(filter => {
      if ('property' in filter && filter.property === 'hs_value' && INVALID_OPERATORS.includes(filter.operation.operator) && !acc.includes(filter.operation.operator)) {
        acc.push(filter.operation.operator);
      }
    });
    return acc;
  }, []);
  return /*#__PURE__*/_jsxs(UIAlert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.header"
    }),
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.paragraph1"
    }), /*#__PURE__*/_jsx(UIList, {
      styled: true,
      children: invalidPropertyValueChangedOperators.map(operator => {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: OPERATOR_LANG_KEY_MAP[operator]
        }, "operator");
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollExistingPanel.propertyChangedBanner.paragraph2"
    })]
  });
};
export default PropertyValueChangedWarningBanner;